export default __webpack_public_path__ + "static/media/dai.eddb22f9.svg";